import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { AddressField } from "../../components/address-field/address-field.js";
import { getIsRequired } from "../helpers/getIsRequired.js";
import { combinedFields } from "../yup/main.js";
import "react-i18next";
import "@mui/material";
import "formik";
import "../helpers/getHasError.js";
import "../hooks/useAddressSuggestions.js";
import "use-debounce";
import "../helpers/googlePlaces.js";
import "../helpers/places.js";
import "../hooks/useFormHelpers.js";
import "../hooks/useSubmitCount.js";
import "./TextField.js";
import "./TextFieldLabel.js";
import "../../components/field-helper-text/field-helper-text.js";
import "../../components/translate/translate.js";
import "yup";
import "../fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../../components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../helpers/toBoolean.js";
import "../helpers/createFields.js";
import "../helpers/resetFields.js";
import "../yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../helpers/predicates.js";
import "../yup/emailValidation.js";
import "../fields/contactDetails.js";
import "../helpers/featureFlags.js";
import "../helpers/getAgeFromBirthday.js";
import "../yup/buildValidationSchema.js";
import "../fields/miscellaneous.js";
import "../fields/insurance.js";
import "../fields/allergiesAndMedications.js";
import "../../../../../type/Disease.js";
import "../config/medicaments.js";
import "../fields/wishesAndExpectations.js";
import "../fields/consents.js";
import "../fields/profileInterest.js";
const streetField = combinedFields.street;
const AddressLayoutItem = ({
  formHelpers: { setFieldValue },
  field = streetField
}) => {
  var _a;
  const handleReceiveAddress = useCallback(
    (address) => {
      setFieldValue("zipCode", address.zipCode);
      setFieldValue("city", address.city);
      setFieldValue("addressGoogleVerified", true);
    },
    [setFieldValue]
  );
  return /* @__PURE__ */ jsx(
    AddressField,
    {
      name: field.name,
      label: field.label,
      required: getIsRequired(field.isRequired),
      helperText: field.justificativeTooltipText,
      placeholder: (_a = field.inputProps) == null ? void 0 : _a.placeholder,
      onReceiveAddress: handleReceiveAddress
    }
  );
};
export {
  AddressLayoutItem
};
